<template>
  <input
    ref="inputRef"
    @blur="$emit('blur')"
    :class="$style.input"
    :style="`border-color: ${widgetSettings.color}`"
    :name="name"
  />
</template>

<script setup lang="ts">
import { useCompanyStore } from '@/stores/company';
import widgetSettings from '@/widget-settings';
import { watch } from 'vue';
import { ValueScaling, useCurrencyInput } from 'vue-currency-input';

const { settings } = useCompanyStore();
const props = defineProps<{
  modelValue: number;
  name: string;
}>();

const { inputRef, setValue } = useCurrencyInput({
  currency: settings.currency || 'EUR',
  locale: 'nl',
  precision: 2,
  valueScaling: ValueScaling.precision
});

watch(
  () => props.modelValue,
  (value) => {
    setValue(value);
  }
);
</script>

<style lang="scss" module>
.input {
  width: 100%;
  height: 51px;
  padding: 3px 10px;
  border-radius: 8px;
  background-color: white;
  border: 1px solid;
  transition: border-color 0.15s;
  transition: color 0.12s;

  &:not(:focus) {
    border-color: $color-border-input !important;
  }
}
</style>
